<section class="rider" id="rider">
  <div class="rider-visual">
    <div class="rider-circle"></div>
    <img class="rider-img" src="/images/rider.png" alt="Become a rider" />
  </div>

  <div class="rider-content">
    <span class="rider-tag">Join our fleet</span>
    <h2>Become a Rider and Earn on Your Own Schedule</h2>
    <p>
      Deliver with OrderYaa and turn your free time into income. Flexible hours, weekly
      payouts, and support every step of the way — all you need is a bike and a phone.
    </p>

    <ul class="rider-perks">
      <li>Flexible working hours</li>
      <li>Weekly payments</li>
      <li>Earn extra with every delivery</li>
    </ul>

    <a
      class="rider-cta"
      [href]="riderUrl"
      target="_blank"
      rel="noopener"
    >
      Become a Rider
    </a>
  </div>
</section>
